<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>运营商销售统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 统计图表 strat -->
      <el-tab-pane label="统计图表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择设备类型" class="select2">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

       <el-row :gutter="24">
          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">分月图表</div>
              <ve-histogram :data="ListMonth" :extend="myExtend" :legend-visible="false" :colors="dataColors"></ve-histogram>
            </el-card>
          </el-col>

          <el-col :span="12">
            <el-card class="box-card">
              <div class="card_title">累计图表</div>
              <ve-histogram :data="ListAll" :extend="myExtend" :legend-visible="false" :colors="dataColors"></ve-histogram>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- 统计图表 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyReportYunyingshangSales',
  data () {
    this.myExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      },
      xAxis: {
        type: 'category',
        // data: ['1页', '2页', '3页', '4页', '5页', '6-10页', '11-20页', '20+页'],
        // xAxis的属性，设置x轴文本不隐藏，同理yAxis也有
        axisLabel: {
          interval: 0, // 坐标轴刻度标签的显示间隔
          rotate: 30 // 标签倾斜的角度
        }
      }
    }
    return {
      activeName: 'first',
      optionsproduct: [],
      // 查询
      keywords: {
        begintime: '',
        bomsn: ''
      },
      dataColors: ['#4ad2ff'],
      ListMonth: {
        columns: ['运营商', '销量'],
        rows: []
      },
      ListAll: {
        columns: ['运营商', '销量'],
        rows: []
      }
    }
  },
  mounted () {
    this.keywords.begintime = Vue.prototype.FunGetTimeStringShortFirst()
    this.apiGetWorkprojectList()
  },
  methods: {
    clicksearch () {
      this.apiGetReportYunyingshangSales()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: 1
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype === 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
                // RSL-6.0T
                if (item1.Bomsn === '103-0000-0002') {
                  that.keywords.bomsn = item1.Bomsn
                }
                // RSL-Mini
                if (item1.Bomsn === '103-0000-0001') {
                  that.keywords.bomsn = item1.Bomsn
                }
              }
            })
            if (that.keywords.bomsn === '') {
              that.keywords.bomsn = that.optionsproduct[0].value
            }
            that.apiGetReportYunyingshangSales()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetReportYunyingshangSales: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetReportYunyingshangSales, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ListMonth.rows = []
            that.ListAll.rows = []
            response.data.ListMonth.forEach((item) => {
              that.ListMonth.rows.push({ 运营商: item.Name, 销量: item.Num })
            })
            response.data.ListAll.forEach((item) => {
              that.ListAll.rows.push({ 运营商: item.Name, 销量: item.Num })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .cell {
      white-space: pre-wrap;
  }
</style>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select1 {
    width: 109px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

.productdata3 {
  padding-right: 5px;
}

.box-card{
    margin-top: 5px;
    margin-bottom: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
